export function getEnvironmentConfig(x: string) {
  const host = window.location.host;
  let env = !host.includes("dev.payinver") && !host.includes("localhost") ? "PROD" : "DEV";
  const basename = "REACT_APP_"
  return process.env[basename + env + "_" + x];
}
